import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { useGetTaxFormsTaxUsFormsGet } from "@/api-v3";
import { CardContainer } from "@/components/card-container";
import { ErrorCard } from "@/components/error-card";
import { Button } from "@/components/ui/button";
import { parseError } from "@/lib/error-handler";
import { AppRoute } from "@/types/routes";

import { TaxFormsList } from "./components/tax-form-list";
import { TaxFormsSkeleton } from "./components/tax-forms-skeleton";
import { TaxPreview } from "./components/tax-preview";
import { DisplayMode } from "./components/tax-preview.types";

export const USTaxPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const {
    data,
    isLoading: loading,
    isError,
    refetch,
    error,
  } = useGetTaxFormsTaxUsFormsGet();

  if (loading) {
    return <TaxFormsSkeleton />;
  }

  if (isError) {
    const { title, message } = parseError(error);
    return (
      <ErrorCard
        title={t(title)}
        message={t(message)}
        buttonLabel={t("retry")}
        onButtonClick={() => refetch()}
      />
    );
  }

  if (!data?.data || data.data.length === 0)
    return (
      <TaxPreview
        mode={DisplayMode.fullpage}
        onContinue={() => {
          navigate(AppRoute.TAX_ONBOARDING);
        }}
      />
    );

  return (
    <CardContainer>
      <CardContainer.Header>
        <CardContainer.HeaderContent>
          <CardContainer.CardTitle>{t("tax")}</CardContainer.CardTitle>
          <CardContainer.CardDescription>
            {t("tax_submit")}
          </CardContainer.CardDescription>
        </CardContainer.HeaderContent>
        <CardContainer.TopRightContent>
          <Button onClick={() => navigate("/tax/submit")}>
            {t("tax_update")}
          </Button>
        </CardContainer.TopRightContent>
      </CardContainer.Header>
      <CardContainer.Content>
        <TaxFormsList data={data.data} />
      </CardContainer.Content>
    </CardContainer>
  );
};
